import {
  useBillingSummary,
  useCatalogueViewViewModel,
  type CatalogueViewViewModel,
  type Source,
} from "@onetasklist/shared";
import { useApi } from "@api/useApi";

// Re-exported from shared for React Native reuse.
export {
  useCatalogueViewViewModel,
  CATALOGUE_ALL_CATEGORIES,
} from "@onetasklist/shared";
export type { CatalogueViewViewModel } from "@onetasklist/shared";

/** The shared catalogue view model, with the user's plan so each source can show its tier or trial badge. */
export const useCatalogueViewWithBillingViewModel = (
  allSources: Source[],
  searchText: string,
): CatalogueViewViewModel => {
  const api = useApi();
  const { data: billing } = useBillingSummary(api.billing);
  return useCatalogueViewViewModel(allSources, searchText, billing);
};
